import { createAsyncThunk } from "@reduxjs/toolkit";
import playlistService from "../../../api/services/playlist";

export const fetchPlaylists = createAsyncThunk(
  "playlists/fetch-playlists",
  async (requestData) => {
    return await playlistService.getPlaylists(requestData);
  },
);

export const fetchMyPlaylists = createAsyncThunk(
  "playlists/fetch-my-playlists",
  async (requestData) => {
    return await playlistService.getMyPlaylists(requestData);
  },
);

export const fetchPlaylist = createAsyncThunk(
  "playlists/fetch-playlist",
  async (requestData) => {
    return await playlistService.getPlaylist(requestData);
  },
);

export const createPlaylist = createAsyncThunk(
  "playlists/create-playlist",
  async (requestData) => {
    return await playlistService.createPlaylist(requestData);
  },
);

export const editPlaylist = createAsyncThunk(
  "playlists/edit-playlist",
  async (requestData) => {
    return await playlistService.editPlaylist(requestData);
  },
);

export const removePlaylist = createAsyncThunk(
  "playlists/remove-playlist",
  async (requestData) => {
    return await playlistService.deletePlaylist(requestData);
  },
);

export const toggleFavoritePlaylist = createAsyncThunk(
  "playlists/toggle-favorite-playlist",
  async (requestData) => {
    return await playlistService.toggleToFavorite(requestData);
  },
);

export const addCollectionToPlaylist = createAsyncThunk(
  "playlists/add-collection-to-playlist",
  async (requestData) => {
    return await playlistService.addCollectionToPlaylist(requestData);
  },
);
